/* =============================================================
   販売期間コントロール（発売前 / 販売終了）
   [data-cs-order-window] の epoch 秒を 1 秒ごとに判定し、
   リロードなしでボタンの活性/非活性・文言を切り替える。
   開始・終了とも未設定の場合は何もしない（従来仕様）。
   ============================================================= */
(function () {
  var TICK_MS = 1000;
  var SCOPE_SEL = '[data-cs-order-window]';
  var BTN_SEL = '[data-size-atc-btn], [data-cs-atc]';

  function ts(scope, attr) {
    var v = parseInt(scope.getAttribute(attr) || '', 10);
    // 0 以下は「未設定 or 変換失敗」とみなして無効化する
    return (isNaN(v) || v <= 0) ? null : v;
  }

  function stateOf(scope) {
    var now = Math.floor(Date.now() / 1000);
    var start = ts(scope, 'data-cs-order-start');
    var stop = ts(scope, 'data-cs-order-stop');
    if (start !== null && now < start) return 'pre';
    if (stop !== null && now >= stop) return 'ended';
    return 'on';
  }

  function isOnSale(scope) {
    return !scope || stateOf(scope) === 'on';
  }

  function apply(scope) {
    var state = stateOf(scope);
    var blocked = state !== 'on';
    var label = blocked
      ? (scope.getAttribute(state === 'pre' ? 'data-cs-label-pre' : 'data-cs-label-ended') || '')
      : '';

    scope.setAttribute('data-cs-order-state', state);

    scope.querySelectorAll(BTN_SEL).forEach(function (btn) {
      var base = btn.getAttribute('data-cs-base-label');
      if (base === null) {
        base = btn.textContent.trim();
        btn.setAttribute('data-cs-base-label', base);
      }
      if (blocked) {
        btn.classList.add('is-order-blocked');
        btn.setAttribute('disabled', '');
        btn.setAttribute('aria-disabled', 'true');
        if (label && btn.textContent.trim() !== label) btn.textContent = label;
      } else {
        btn.classList.remove('is-order-blocked');
        btn.removeAttribute('aria-disabled');
        if (btn.textContent.trim() !== base) btn.textContent = base;
        // 在庫切れ由来の disabled は解除しない
        var row = btn.closest('.size-atc-row');
        if (!row || !row.classList.contains('is-disabled')) btn.removeAttribute('disabled');
      }
    });
  }

  function applyAll() {
    document.querySelectorAll(SCOPE_SEL).forEach(apply);
  }

  window.csOrderWindow = { applyAll: applyAll, isOnSale: isOnSale, stateOf: stateOf };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }
  setInterval(applyAll, TICK_MS);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) applyAll();
  });
  document.addEventListener('variant:change', function () { setTimeout(applyAll, 0); });
})();


/**
 * custom-size-atc.js
 * イベント委譲でDOM差し替え後も動作
 */
(function () {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-size-atc-btn]');
    if (!btn) return;

    // 販売期間外はカート追加させない
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    const orderScope = btn.closest('[data-cs-order-window]');
    if (orderScope && window.csOrderWindow && !window.csOrderWindow.isOnSale(orderScope)) return;

    const variantId = btn.getAttribute('data-variant-id');




    if (!variantId) return;

    const f = document.createElement('form');
    f.method = 'POST';
    f.action = '/cart/add';

    const inputId = document.createElement('input');
    inputId.type = 'hidden';
    inputId.name = 'id';
    inputId.value = variantId;

    const inputQty = document.createElement('input');
    inputQty.type = 'hidden';
    inputQty.name = 'quantity';
    inputQty.value = '1';

    const inputReturn = document.createElement('input');
    inputReturn.type = 'hidden';
    inputReturn.name = 'return_to';
    inputReturn.value = '/cart';

    f.appendChild(inputId);
    f.appendChild(inputQty);
    f.appendChild(inputReturn);
    document.body.appendChild(f);
    f.submit();
  });

  // カラー変更時にサイズ行を更新
  document.addEventListener('variant:change', function (e) {
    const currentVariant = e.detail?.variant;
    if (!currentVariant) return;

    const formId = e.detail?.formId;
    const sizeList = formId
      ? document.querySelector(`[form-id="${formId}"] [data-size-atc-list]`)
      : document.querySelector('[data-size-atc-list]');
    if (!sizeList) return;

    const productHandle = sizeList.closest('variant-picker')?.getAttribute('handle');
    if (!productHandle) return;

    fetch(`/products/${productHandle}.js`)
      .then(r => r.json())
      .then(data => {
        const variantsData = data.variants;
        const sizeOptionPosition = parseInt(sizeList.getAttribute('data-option-position'), 10) - 1;

        sizeList.querySelectorAll('.size-atc-row').forEach(row => {
          const sizeValue = row.getAttribute('data-size-value');

          const matchingVariant = variantsData.find(v => {
            if (v.options[sizeOptionPosition] !== sizeValue) return false;
            return v.options.every((opt, i) => {
              if (i === sizeOptionPosition) return true;
              return opt === currentVariant.options[i];
            });
          });

          const atcBtn = row.querySelector('[data-size-atc-btn]');

          if (!matchingVariant || !matchingVariant.available) {
            row.classList.add('is-disabled');
            if (atcBtn) {
              atcBtn.setAttribute('disabled', '');
              atcBtn.setAttribute('data-variant-id', '');
            }
          } else {
            row.classList.remove('is-disabled');
            if (atcBtn) {
              atcBtn.removeAttribute('disabled');
              atcBtn.setAttribute('data-variant-id', String(matchingVariant.id));
            }
          }
        });

        if (window.csOrderWindow) window.csOrderWindow.applyAll();

      });
  });
})();





/* カスタム カート追加ボタン(buy-buttonsとは独立)
   - data-cs-atc="reveal" : サイズ選択(variant-picker)を展開
   - data-cs-atc="add"    : バリエーション無し商品を直接カート追加 */
(function () {
  function csCartAdd(variantId) {
    if (!variantId) return;
    const f = document.createElement('form');
    f.method = 'POST';
    f.action = '/cart/add';
    [['id', variantId], ['quantity', '1'], ['return_to', '/cart']].forEach(function (pair) {
      const i = document.createElement('input');
      i.type = 'hidden';
      i.name = pair[0];
      i.value = pair[1];
      f.appendChild(i);
    });
    document.body.appendChild(f);
    f.submit();
  }

  document.addEventListener('click', function (e) {
    // サイズ選択を展開
    const revealBtn = e.target.closest('[data-cs-atc="reveal"]');
    if (revealBtn) {
      e.preventDefault();
      const handle = revealBtn.getAttribute('data-product-handle');
      const picker = handle
        ? document.querySelector('variant-picker[handle="' + handle + '"]')
        : document.querySelector('variant-picker');
      if (!picker) return;

      picker.classList.remove('is-collapsed');

      const wrap = revealBtn.closest('[data-cs-atc-wrap]') || revealBtn;
      wrap.style.display = 'none';

      const list = picker.querySelector('[data-size-atc-list]') || picker;
      list.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    // バリエーション無し: 直接カート追加
    const addBtn = e.target.closest('[data-cs-atc="add"]');
    if (addBtn) {
      e.preventDefault();

      // 販売期間外はカート追加させない
      if (addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true') return;
      const addScope = addBtn.closest('[data-cs-order-window]');
      if (addScope && window.csOrderWindow && !window.csOrderWindow.isOnSale(addScope)) return;

      csCartAdd(addBtn.getAttribute('data-variant-id'));
    }




  });
})();





/* 商品ページタブ切り替え */
document.addEventListener('click', function (e) {
  const tab = e.target.closest('[data-tab]');
  if (!tab) return;

  const tabsNav = tab.closest('[data-product-tabs]');
  if (!tabsNav) return;

  const targetId = tab.getAttribute('aria-controls');

  // タブボタンの切り替え
  tabsNav.querySelectorAll('.cs-product-tabs__tab').forEach(t => {
    t.classList.remove('is-active');
    t.setAttribute('aria-selected', 'false');
  });
  tab.classList.add('is-active');
  tab.setAttribute('aria-selected', 'true');

  // パネルの切り替え
  tabsNav.querySelectorAll('.cs-product-tabs__panel').forEach(p => {
    p.hidden = true;
    p.classList.remove('is-active');
  });
  const target = document.getElementById(targetId);
  if (target) {
    target.hidden = false;
    target.classList.add('is-active');
  }
});







/* =============================================================
   商品ギャラリー ライトボックス
   メイン画像(.product-gallery__image-list)クリックで拡大表示。
   下部にサムネイル列、スワイプ / 矢印 / サムネイルクリックで切替。
   コア(theme.js / PhotoSwipe)は不使用の自己完結実装。
   ※ セクション設定「画像ズームを有効化」はオフのままにしてください（二重起動防止）。
   ============================================================= */
(function () {
  var GALLERY_SEL = '.product-gallery__image-list';
  var lb, track, thumbsEl, slides = [], index = 0;

  /* ギャラリーと同じ 2:3 に正規化する。
     currentSrc に残っている height / crop を必ず上書きすること。 */
      var IS_STINA = document.body.classList.contains('page-stina');
      var LB_RATIO_W = IS_STINA ? 2 : 3;
      var LB_RATIO_H = IS_STINA ? 3 : 4;

  function hiRes(url, w) {
    try {
      var u = new URL(url, location.href);
      u.searchParams.set('width', w);
      u.searchParams.set('height', Math.round(w * LB_RATIO_H / LB_RATIO_W));
      u.searchParams.set('crop', 'center');
      return u.href;
    } catch (e) {
      return url;
    }
  }

  function collectImages(gallery) {
    var imgs = gallery.querySelectorAll('.product-gallery__media[data-media-type="image"]:not([hidden]) img');
    var data = [];
    imgs.forEach(function (img) {
      var base = img.currentSrc || img.src;
      if (!base) return;
      data.push({ full: hiRes(base, 1600), thumb: hiRes(base, 160), alt: img.alt || '' });
    });
    return data;
  }

  function esc(s) {
    return String(s).replace(/"/g, '&quot;');
  }

  function build() {
    lb = document.createElement('div');
    lb.className = 'cs-lightbox';
    lb.setAttribute('hidden', '');
    lb.innerHTML =
      '<button class="cs-lightbox__close" type="button" aria-label="閉じる">&times;</button>' +
      '<button class="cs-lightbox__nav cs-lightbox__nav--prev" type="button" aria-label="前へ">&#8249;</button>' +
      '<div class="cs-lightbox__viewport"><div class="cs-lightbox__track"></div></div>' +
      '<button class="cs-lightbox__nav cs-lightbox__nav--next" type="button" aria-label="次へ">&#8250;</button>' +
      '<div class="cs-lightbox__caption">Embrace the leotard that reflects your stillness, your rhythm, your tune.</div>' +
      '<div class="cs-lightbox__thumbs"></div>';
    document.body.appendChild(lb);
    track = lb.querySelector('.cs-lightbox__track');
    thumbsEl = lb.querySelector('.cs-lightbox__thumbs');

    lb.querySelector('.cs-lightbox__close').addEventListener('click', close);
    lb.querySelector('.cs-lightbox__nav--prev').addEventListener('click', function () { go(index - 1); });
    lb.querySelector('.cs-lightbox__nav--next').addEventListener('click', function () { go(index + 1); });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('cs-lightbox__viewport')) close();
    });
    attachSwipe();
  }

  function render() {
    track.innerHTML = slides.map(function (s) {
      return '<div class="cs-lightbox__slide"><img src="' + s.full + '" alt="' + esc(s.alt) + '"></div>';
    }).join('');
    thumbsEl.innerHTML = slides.map(function (s, i) {
      return '<button class="cs-lightbox__thumb" type="button" data-i="' + i + '"><img src="' + s.thumb + '" alt=""></button>';
    }).join('');
    thumbsEl.querySelectorAll('.cs-lightbox__thumb').forEach(function (b) {
      b.addEventListener('click', function () { go(parseInt(b.getAttribute('data-i'), 10)); });
    });
  }

  function update() {
    track.style.transform = 'translateX(' + (-index * 100) + '%)';
    thumbsEl.querySelectorAll('.cs-lightbox__thumb').forEach(function (b, i) {
      var active = i === index;
      b.classList.toggle('is-active', active);
      if (active) b.scrollIntoView({ inline: 'center', block: 'nearest' });
    });
  }

  function go(i) {
    if (i < 0) i = 0;
    if (i > slides.length - 1) i = slides.length - 1;
    index = i;
    update();
  }

  function open(start) {
    if (!lb) build();
    var gallery = document.querySelector(GALLERY_SEL);
    if (!gallery) return;
    slides = collectImages(gallery);
    if (!slides.length) return;
    render();
    index = Math.min(Math.max(start || 0, 0), slides.length - 1);
    track.style.transition = 'none';
    update();
    void track.offsetWidth;
    track.style.transition = '';
    lb.removeAttribute('hidden');
    document.documentElement.classList.add('cs-lightbox-open');
  }

  function close() {
    if (!lb) return;
    lb.setAttribute('hidden', '');
    document.documentElement.classList.remove('cs-lightbox-open');
  }

  function attachSwipe() {
    var vp = lb.querySelector('.cs-lightbox__viewport');
    var startX = 0, dx = 0, dragging = false, w = 0;
    vp.addEventListener('pointerdown', function (e) {
      dragging = true;
      startX = e.clientX;
      dx = 0;
      w = vp.clientWidth;
      track.style.transition = 'none';
      try { vp.setPointerCapture(e.pointerId); } catch (err) {}
    });
    vp.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dx = e.clientX - startX;
      track.style.transform = 'translateX(calc(' + (-index * 100) + '% + ' + dx + 'px))';
    });
    function end() {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      if (Math.abs(dx) > w * 0.15) { go(dx < 0 ? index + 1 : index - 1); }
      else { update(); }
      dx = 0;
    }
    vp.addEventListener('pointerup', end);
    vp.addEventListener('pointercancel', end);
  }

  // メイン画像クリックで開く
  document.addEventListener('click', function (e) {
    var mediaEl = e.target.closest(GALLERY_SEL + ' .product-gallery__media[data-media-type="image"]');
    if (!mediaEl) return;
    var gallery = mediaEl.closest(GALLERY_SEL);
    var visible = Array.prototype.slice.call(
      gallery.querySelectorAll('.product-gallery__media[data-media-type="image"]:not([hidden])')
    );
    var start = visible.indexOf(mediaEl);
    e.preventDefault();
    open(start < 0 ? 0 : start);
  });

  // キーボード操作
  document.addEventListener('keydown', function (e) {
    if (!lb || lb.hasAttribute('hidden')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') go(index - 1);
    else if (e.key === 'ArrowRight') go(index + 1);
  });
})();



/* =============================================================
   商品ギャラリー ライトボックスここまで
   ============================================================= */